"use client";

import styles from "./styles.module.scss";
import { useRouter } from "next/navigation";
import { VideosSet } from "../../component-nextv3/VideoSet/indx";
import { THEME_SETTING } from "@/setting/setting";
import { Options } from "@splidejs/splide";
import { Splide } from "@splidejs/react-splide";
import { useResponsive } from "@/core-nextv3/util/useResponsive";
import { ImageSet } from "@/component-nextv3/ImageSet";
import CustomLink from "@/component-nextv3/CustomLink";

interface PageBannerProps {
    banners: any,
}

export const PageBanner = ({ banners }:PageBannerProps) => 
{
    const { isDesktop } = useResponsive();
    const router = useRouter();

    const mainOptions : Options = {
        role         : "banner",
        type         : "loop",
        rewind       : true,
        perPage      : 1,
        perMove      : 1,
        pagination   : false,
        slideFocus   : true,
        lazyLoad     : "nearby",
        preloadPages : 1,
        start        : 0,
        arrows       : true,
        autoplay     : true,
        interval     : 3000,
    }

    return (
        <section className={styles.pageBanner}>
            <Splide
                options={mainOptions}
            >
                {banners && banners?.length > 0 && banners?.map((item:any, index:any) => (

                    isDesktop ? item.status && <div key={index + "-desktop"} className="splide__slide">
                        <CustomLink href={item?.url || "#"}>
                            {item?.type?.value === "video" ? 
                                <VideosSet video={item.videoDesktop} 
                                    controls={false} 
                                    autoplay={true} 
                                    loop={true} 
                                    width={THEME_SETTING.widthBannerMain || 1600}
                                    height={THEME_SETTING.heightBannerMain || 850}/> :
                                //<img className={styles.image} onClick={() => router.push(item?.url || "#")} src={cloudflareLoader({ src : item?.desktop?._url, width : 1600 })}/>
                                // <div className={styles.image} onClick={() => router.push(item?.url || "#")} style={{ backgroundSize : "100%", backgroundRepeat : "no-repeat", backgroundImage : "url(\"" + cloudflareLoader({ src : item?.desktop?._url, width : 1600 }) + "\")" }}>
                                <ImageSet
                                    width={1600}
                                    height={450}
                                    priority
                                    src={item?.desktop?._url}
                                    className={styles.desktop}
                                    alt=""
                                />   
                                // </div>
                            }
                        </CustomLink>
                    </div>
                        
                        :
                    
                        item.status &&  <div key={index + "-mobile"} className="splide__slide">
                            <CustomLink href={item?.url || "#"}>
                                {item?.type?.value === "video" ? 
                                    <VideosSet video={item.videoMobile} 
                                        controls={false} 
                                        autoplay={true} 
                                        loop={true} 
                                        width={THEME_SETTING.widthBannerMainMobile || 1500}
                                        height={THEME_SETTING.heightBannerMainMobile ||  2160}/> :
                                // <div className={styles.image} onClick={() => router.push(item?.url || "#")} style={{ backgroundSize : "100%", backgroundRepeat : "no-repeat", backgroundImage : "url(\"" + cloudflareLoader({ src : item?.mobileImage?._url, width : 1500 }) + "\")" }}/>
                                    <ImageSet
                                        width={1500}
                                        height={2160}
                                        priority
                                        onClick={() => router.push(item?.url || "#")}
                                        src={item?.mobileImage?._url}
                                        className={styles.mobileImage}
                                        alt=""
                                    />}
                            </CustomLink>
                        </div>
            
                ))}
                
            </Splide>            
        </section>
    );
};
